import { displayMessage } from "../../../helpers/messages";

// Mapeamento de tipos para exibição
const TYPE_LABELS = {
    weight_loss: displayMessage("WEIGHT_LOSS"),
    muscle_gain: displayMessage("MUSCLE_GAIN"),
};

// Mapeamento de gêneros para exibição
const GENDER_LABELS = {
    male: displayMessage("MALE"),
    female: displayMessage("FEMALE"),
};

const INTOLERANCE_LABELS = {
    none: "Nenhuma",
    lactose: "Lactose",
    gluten: "Glúten",
    vegetarian: "Vegetariano",
};

const diet_grid_columns = [
    {
        field: "id",
        headerName: displayMessage("ID"),
        flex: 0.5,
        minWidth: 60,
    },
    {
        field: "gender",
        headerName: displayMessage("GENDER"),
        flex: 1,
        minWidth: 120,
        // valueGetter garante que filtro, ordenação e exibição usam o texto traduzido
        valueGetter: (params) => GENDER_LABELS[params.value] || params.value,
    },
    {
        field: "type",
        headerName: displayMessage("DIET_TYPE"),
        flex: 1.5,
        minWidth: 150,
        valueGetter: (params) => TYPE_LABELS[params.value] || params.value,
    },
    {
        field: "meals_count",
        headerName: displayMessage("MEALS_COUNT"),
        flex: 1,
        minWidth: 120,
        valueGetter: (params) => `${params.value} ${displayMessage("MEALS")}`,
    },
    {
        field: "food_intolerance",
        headerName: "Intolerância",
        flex: 1.5,
        minWidth: 150,
        valueGetter: (params) => INTOLERANCE_LABELS[params.value] || params.value,
    },
    {
        field: "sequence",
        headerName: displayMessage("SEQUENCE"),
        flex: 0.6,
        minWidth: 90,
        valueGetter: (params) => params.row?.sequence ?? 1,
    },
    {
        field: "description",
        headerName: displayMessage("DESCRIPTION"),
        flex: 2,
        minWidth: 200,
        valueGetter: (params) => params.value || "-",
    },
    {
        field: "file",
        headerName: displayMessage("PDF_FILE"),
        flex: 1.5,
        minWidth: 150,
        valueGetter: (params) => params.value || "-",
    },
];

// Colunas da Etapa 2 (dentro de uma combinação já selecionada).
// Omite os campos que definem a combinação (gender, type, meals_count,
// food_intolerance) pois são fixos dentro do agrupamento, e coloca a
// sequência em primeiro lugar como ordenador principal.
const diet_grid_columns_stage2 = [
    {
        field: "sequence",
        headerName: displayMessage("SEQUENCE"),
        flex: 0.6,
        minWidth: 90,
        valueGetter: (params) => params.row?.sequence ?? 1,
    },
    {
        field: "id",
        headerName: displayMessage("ID"),
        flex: 0.5,
        minWidth: 60,
    },
    {
        field: "description",
        headerName: displayMessage("DESCRIPTION"),
        flex: 2,
        minWidth: 200,
        valueGetter: (params) => params.value || "-",
    },
    {
        field: "file",
        headerName: displayMessage("PDF_FILE"),
        flex: 1.5,
        minWidth: 150,
        valueGetter: (params) => params.value || "-",
    },
];

export default diet_grid_columns;
export { diet_grid_columns_stage2 };
